module.exports = __webpack_public_path__ + "22f73d32ff3d290b087b8b7d590ec01a.svg";